module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mall-header'), _vm._v(" "), _c('mall-bread', [_c('span', {
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v("商品详情")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.fullscreenLoading),
      expression: "fullscreenLoading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    staticClass: "details-css"
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('img', {
    staticClass: "details-img",
    attrs: {
      "src": _vm.detailobj.imgUrl
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "440px",
      "padding-bottom": "40px"
    }
  }, [_c('div', [_c('div', {
    staticClass: "details-info-css"
  }, [_vm._v(_vm._s(_vm.detailobj.name))]), _vm._v(" "), _c('div', {
    staticClass: "details-info-title-css"
  }, [_vm._v(_vm._s(_vm.detailobj.description))])]), _vm._v(" "), _c('div', {
    staticClass: "sku-custom-title"
  }, [_c('h6', [_c('span'), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_c('em', [_vm._v("¥")]), _c('i', [_vm._v(" " + _vm._s(_vm.detailobj.unitPrice))])])])]), _vm._v(" "), _c('div', {
    staticClass: "details-info-num"
  }, [_c('span', {
    staticClass: "select-num-css"
  }, [_vm._v("选择数量")]), _vm._v(" "), _c('el-input-number', {
    staticClass: "elInputNumber ",
    staticStyle: {
      "margin-left": "10px",
      "border-radius": "0px",
      "height": "36px"
    },
    attrs: {
      "size": "large",
      "min": 1,
      "v-bind": _vm.detailobj.unit
    },
    model: {
      value: (_vm.num),
      callback: function($$v) {
        _vm.num = $$v
      },
      expression: "num"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "details-info-fen"
  }, [_vm._v(_vm._s(_vm.detailobj.unit))])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy"
  }, [_c('y-button', {
    staticClass: "details-button-go",
    attrs: {
      "text": "立即购买"
    },
    on: {
      "btnClick": function($event) {
        return _vm.shopPay()
      }
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "position": "absolute",
      "margin-left": "35px",
      "margin-top": "12px"
    },
    attrs: {
      "src": require("../../static/images/buttonShopCart.png")
    }
  }), _vm._v(" "), _c('y-button', {
    staticClass: "details-button-join",
    attrs: {
      "text": "     加入购物车"
    },
    on: {
      "btnClick": function($event) {
        return _vm.addCart()
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "detail-server-div"
  }, [_c('span', {
    staticClass: "detail-server-font"
  }, [_vm._v("服务详情")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "90px 30px 30px 30px",
      "text-align": "center"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.detailobj.detail)
    }
  }), _vm._v(" "), _c('el-backtop', {
    staticStyle: {
      "right": "initial",
      "bottom": "40px"
    }
  }, [_c('div', {
    staticClass: "el-backtop-div"
  }, [_c('img', {
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "src": require("../../static/images/backtop.png")
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "left": "0px",
      "bottom": "0px",
      "width": "100%",
      "z-index": "1",
      "text-align": "center",
      "padding": "20px 0",
      "color": "#999999",
      "font-size": "14px"
    }
  }, [_vm._v("\n      Copyright ©2021 深圳市东宝信息技术有限公司 All Rights Reserved\n    ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2bd61822!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/GoodsDetails.vue
// module id = 324
// module chunks = 2